// extracted by mini-css-extract-plugin
export var headline6 = "bD_fn";
export var menuContainer = "bD_fk";
export var menuItem = "bD_fm";
export var menuList = "bD_fl";